import React from "react";

const BS5_GridXXL = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_GridXXL Component</h2>
      <p>This is the BS5_GridXXL component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_GridXXL;
